import React from 'react';

const PrivacyPolicyPage = () => {
    return (
        <div className="min-h-screen bg-gray-900 text-white font-inter py-16 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
                {/* Sayfa Başlığı ve Giriş Bölümü */}
                <header className="text-center mb-12 md:mb-16">
                    <h1 className="text-5xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500 mb-4 drop-shadow-md">
                        Gizlilik Politikası
                    </h1>
                    <p className="text-lg text-gray-400 max-w-2xl mx-auto">
                        Mekânname olarak, kullanıcılarımızın gizliliğine büyük önem veriyoruz. Bu politika, uygulamamızı kullanırken hangi verileri topladığımızı, bu verileri nasıl kullandığımızı ve koruduğumuzu açıklamaktadır.
                    </p>
                </header>

                {/* İçerik Bölümleri */}
                <main className="space-y-8">
                    {/* Topladığımız Veriler */}
                    <section className="bg-gray-800/40 backdrop-blur-sm rounded-xl p-6 md:p-10 shadow-xl border border-gray-700">
                        <h2 className="text-2xl md:text-3xl font-bold text-indigo-400 mb-4 border-b border-indigo-500 pb-2">
                            1. Topladığımız Veriler
                        </h2>
                        <p className="text-gray-300 leading-relaxed mb-4">
                            Uygulamamız, hizmetlerimizi sunmak ve geliştirmek amacıyla çeşitli veriler toplar. Bu veriler şunları içerebilir:
                        </p>
                        <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                            <li>
                                <span className="font-semibold text-white">Cihaz Bilgileri:</span> IP adresi, cihaz modeli, işletim sistemi ve tarayıcı türü gibi bilgileri toplarız.
                            </li>
                            <li>
                                <span className="font-semibold text-white">Kullanım Verileri:</span> Uygulama içinde ziyaret ettiğiniz sayfalar, harcadığınız süre ve etkileşimde bulunduğunuz özellikler gibi anonim kullanım verilerini toplarız.
                            </li>
                            <li>
                                <span className="font-semibold text-white">Yüklenen Fotoğraflar:</span> Kullanıcıların tarihi mekan tespiti için yüklediği fotoğraflar, yalnızca yapay zeka analizleri için kullanılır ve kısa süre sonra sunucularımızdan silinir.
                            </li>
                        </ul>
                    </section>

                    {/* Verileri Nasıl Kullanıyoruz */}
                    <section className="bg-gray-800/40 backdrop-blur-sm rounded-xl p-6 md:p-10 shadow-xl border border-gray-700">
                        <h2 className="text-2xl md:text-3xl font-bold text-teal-400 mb-4 border-b border-teal-500 pb-2">
                            2. Verileri Nasıl Kullanıyoruz
                        </h2>
                        <p className="text-gray-300 leading-relaxed mb-4">
                            Topladığımız verileri şu amaçlarla kullanırız:
                        </p>
                        <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                            <li>Hizmetlerimizi sunmak ve kişiselleştirmek.</li>
                            <li>Uygulamanın performansını ve kullanıcı deneyimini iyileştirmek.</li>
                            <li>Kullanım trendlerini analiz etmek ve yeni özellikler geliştirmek.</li>
                            <li>Güvenlik önlemlerini güçlendirmek ve olası sorunları gidermek.</li>
                        </ul>
                    </section>
                    
                    {/* Üçüncü Taraflarla Paylaşım */}
                    <section className="bg-gray-800/40 backdrop-blur-sm rounded-xl p-6 md:p-10 shadow-xl border border-gray-700">
                        <h2 className="text-2xl md:text-3xl font-bold text-indigo-400 mb-4 border-b border-indigo-500 pb-2">
                            3. Üçüncü Taraflarla Paylaşım
                        </h2>
                        <p className="text-gray-300 leading-relaxed">
                            Kişisel verileriniz, izniniz olmadan veya yasal zorunluluklar dışında üçüncü taraflarla paylaşılmaz. Uygulamamız, anonimleştirilmiş kullanım verilerini hizmetlerimizi geliştirmek için analiz hizmeti sağlayan iş ortaklarımızla paylaşabilir.
                        </p>
                    </section>

                    {/* Veri Güvenliği */}
                    <section className="bg-gray-800/40 backdrop-blur-sm rounded-xl p-6 md:p-10 shadow-xl border border-gray-700">
                        <h2 className="text-2xl md:text-3xl font-bold text-teal-400 mb-4 border-b border-teal-500 pb-2">
                            4. Veri Güvenliği
                        </h2>
                        <p className="text-gray-300 leading-relaxed">
                            Verilerinizin güvenliğini sağlamak için teknik ve idari güvenlik önlemleri alıyoruz. Sunucularımızda saklanan tüm veriler, yetkisiz erişime karşı korunmaktadır.
                        </p>
                    </section>
                </main>
            </div>
        </div>
    );
};

export default PrivacyPolicyPage;